import { render } from "./IDPReportCard.vue?vue&type=template&id=235fd340&scoped=true"
import script from "./IDPReportCard.vue?vue&type=script&lang=js"
export * from "./IDPReportCard.vue?vue&type=script&lang=js"

import "./IDPReportCard.vue?vue&type=style&index=0&id=235fd340&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235fd340"]])

export default __exports__